import { request } from 'client/modules/common/utils/request';

/**
 *
 * @param req UpdateTeamRequest - TODO PAB-2106: Fix Request type
 * @returns
 */
export const updateTeam = (req: any): Promise<void> =>
  request({
    url: '/service/adminservice/UpdateTeam',
    body: req,
  }).then((r) => r.body);
